module.exports = __webpack_public_path__ + "media/img/events/bg/location-04b82ef7d2a304ce46e3ffcd2a4a96d7.jpg";